
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

type TableName = 'profiles' | 'services' | 'bookings' | 'regions' | 'categories' | 'reviews';

export interface CountResult {
  count: number;
  isLoading: boolean;
  error: Error | null;
}

export function useSupabaseCount(table: TableName, queryKey: string): CountResult {
  const query = useQuery({
    queryKey: [queryKey],
    queryFn: async () => {
      try {
        console.log(`Fetching count for ${table}...`);
        const { count, error } = await supabase
          .from(table)
          .select('*', { count: 'exact', head: true });
        
        if (error) {
          console.error(`Error fetching ${table} count:`, error);
          throw error;
        }
        
        return { count: count || 0 };
      } catch (err) {
        console.error(`Error in useSupabaseCount for ${table}:`, err);
        throw err;
      }
    },
    refetchOnWindowFocus: false,
  });

  return {
    count: query.data?.count ?? 0,
    isLoading: query.isLoading,
    error: query.error as Error | null
  };
}
